import React from 'react';

import { FaRegFolderOpen } from 'react-icons/fa6';
import { GoHome } from 'react-icons/go';
import { IoIosSend } from 'react-icons/io';
import { IconBaseProps } from 'react-icons/lib';
import {
  MdAdd,
  MdCancel,
  MdCheck,
  MdCheckCircle,
  MdClose,
  MdCloudDone,
  MdContentCopy,
  MdDeleteForever,
  MdDownload,
  MdDriveFileMove,
  MdEdit,
  MdError,
  MdHideSource,
  MdHome,
  MdInfo,
  MdLanguage,
  MdLockOutline,
  MdLogin,
  MdLogout,
  MdNotifications,
  MdOutlineCloudUpload,
  MdOutlineInbox,
  MdOutlinePerson,
  MdOutlineSettings,
  MdRefresh,
  MdSearch,
  MdShare,
  MdSync,
  MdVisibility,
  MdVpnKey,
  MdWarning,
} from 'react-icons/md';
import { COLORS } from '../../../Colors';

export type iconTypes = (typeof iconTypesArray)[number];
interface CommonIconProps extends IconBaseProps {
  icon: iconTypes;
}

export const iconTypesArray = [
  'Add',
  'Check',
  'CheckCircle',
  'Cancel',
  'Copy',
  'Close',
  'Delete',
  'Download',
  'Edit',
  'Error',
  'Folder',
  'Hide',
  'Home',
  'Inbox',
  'Info',
  'Key',
  'Language',
  'Lock',
  'Login',
  'Logout',
  'Move',
  'Notifications',
  'Person',
  'Profile',
  'Refresh',
  'Register',
  'Search',
  'SecureInBox',
  'SecurePassword',
  'SecureSync',
  'SecureVault',
  'Send',
  'Settings',
  'Share',
  'SmartShare',
  'Sync',
  'Upload',
  'UploadDone',
  'Vault',
  'View',
  'Warning',
  'World',
] as const;

// Mappa di stringhe -> Componenti icona
const all_icons: Record<iconTypes, React.FC<IconBaseProps>> = {
  Add: MdAdd,
  Check: MdCheck,
  CheckCircle: MdCheckCircle,
  Cancel: MdCancel,
  Copy: MdContentCopy,
  Close: MdClose,
  Delete: MdDeleteForever,
  Download: MdDownload,
  Edit: MdEdit,
  Error: MdError,
  Folder: FaRegFolderOpen,
  Move: MdDriveFileMove,
  Hide: MdHideSource,
  Home: GoHome,
  Inbox: MdOutlineInbox,
  Info: MdInfo,
  Key: MdVpnKey,
  Language: MdLanguage,
  Lock: MdLockOutline,
  Login: MdLogin,
  Logout: MdLogout,
  Notifications: MdNotifications,
  Person: MdOutlinePerson,
  Profile: MdOutlinePerson,
  Refresh: MdRefresh,
  Register: MdLogin,
  Search: MdSearch,
  SecureInBox: MdOutlineInbox,
  SecurePassword: MdVpnKey,
  SecureSync: MdSync,
  SecureVault: MdLockOutline,
  Send: IoIosSend,
  Settings: MdOutlineSettings,
  Share: MdShare,
  SmartShare: MdShare,
  Sync: MdSync,
  Upload: MdOutlineCloudUpload,
  UploadDone: MdCloudDone,
  Vault: MdHome,
  View: MdVisibility,
  Warning: MdWarning,
  World: MdLanguage,
};

const CommonIcon = ({
  icon,
  color = COLORS.primary,
  ...rest
}: CommonIconProps) => {
  const IconComponent = all_icons[icon];
  const classNames = rest.className || '' + ' ic1-icon';
  return (
    <IconComponent color={color} size={20} {...rest} className={classNames} />
  );
};

export default CommonIcon;
